import { JetView } from 'webix-jet';

/**
 * Class representing the details landing report view.
 * @extends JetView
 */
export default class detailsLandingReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Main information layout
        const main_info = {
            margin: 10,
            rows: [
                {
                    cols: [
                        {
                            rows: [
                                {
                                    view: 'text',
                                    name: 'Id',
                                    label: _("<span class='icon-id'></span> ID"), // ID label with icon
                                    labelPosition: 'top',
                                    placeholder: _('Id'), // Placeholder for ID
                                    invalidMessage: _('A ID is required'), // Validation message
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Type',
                                    label: _('Tipo'), // Type label
                                    labelPosition: 'top',
                                    placeholder: _('Tipo'), // Placeholder for Type
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Date',
                                    label: _('Fecha'), // Date label
                                    labelPosition: 'top',
                                    placeholder: _('Fecha'), // Placeholder for Date
                                    disabled: true, // Field is disabled
                                },
                                {
                                    view: 'text',
                                    name: 'Amount',
                                    label: _('Monto'), // Amount label
                                    labelPosition: 'top',
                                    placeholder: _('Monto'), // Placeholder for Amount
                                    disabled: true, // Field is disabled
                                    id: 'Monto', // ID for Amount field
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        // Left main layout configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Upper section layout with multiview
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main],
        };

        // Narrow upper section layout
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Details casino window configuration
        const detailsCasino = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsCasino',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2', // ID for details form
                type: 'clean',
                padding: 10,
                rows: [upper_section_narrow],
            },
        });

        // Main return configuration for the view
        return {
            view: 'form',
            id: 'formDetails', // ID for the main form
            rows: [
                screen.width > 500 && screen.height > 500
                    ? upper_section // Display upper section if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(this.app, 'bonusTransDetail:select', (person) => {
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Monto').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set Amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for narrow view
            }
        });
    }
}

// FILE DOCUMENTED
